import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Sidebar, { MobileNav } from "@/components/Sidebar";
import { SubsProvider } from "@/context/SubsContext";

import Dashboard from "@/pages/Dashboard";
import Subscriptions from "@/pages/Subscriptions";
import Savings from "@/pages/Savings";
import Simulator from "@/pages/Simulator";
import Calendar from "@/pages/Calendar";
import SettingsPage from "@/pages/Settings";

function Layout() {
  const location = useLocation();
  const titles = {
    "/": "Tableau de bord",
    "/abonnements": "Mes abonnements",
    "/economies": "Mes économies",
    "/simulateur": "Simulateur",
    "/calendrier": "Calendrier",
    "/parametres": "Paramètres",
  };
  const title = titles[location.pathname] || "SubSave";

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <header className="sticky top-0 z-30 bg-white/70 backdrop-blur-xl border-b border-gray-100">
          <div className="px-5 lg:px-10 py-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="lg:hidden h-8 w-8 rounded-lg bg-emerald-600 flex items-center justify-center">
                <span className="text-white font-heading font-bold text-xs">S</span>
              </div>
              <div>
                <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-emerald-600">
                  SubSave
                </div>
                <h1
                  className="font-heading text-xl sm:text-2xl font-bold text-gray-900 tracking-tight"
                  data-testid="page-title"
                >
                  {title}
                </h1>
              </div>
            </div>
          </div>
        </header>
        <main className="flex-1 px-5 lg:px-10 py-6 lg:py-10 pb-24 lg:pb-10 max-w-[1400px] w-full mx-auto">
          <Outlet />
        </main>
        <MobileNav />
      </div>
    </div>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SubsProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/abonnements" element={<Subscriptions />} />
              <Route path="/economies" element={<Savings />} />
              <Route path="/simulateur" element={<Simulator />} />
              <Route path="/calendrier" element={<Calendar />} />
              <Route path="/parametres" element={<SettingsPage />} />
            </Route>
          </Routes>
          <Toaster richColors position="top-right" />
        </SubsProvider>
      </BrowserRouter>
    </div>
  );
}
